// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { i18n } from '../../index'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import StationPage from '../station/StationPage'
import ChecklistPage from './ChecklistPage'
import { fetchStationChecklistItems } from './checklistQueries'
import type { ChecklistItem } from './checklistTypes'

const StationChecklistPage = () => (
  <StationPage title={i18n.t('admin.stations.title.checklists')}>
    {({ station }) => (
      <Query<
        {
          checklistItems: Array<ChecklistItem>
        },
        Record<string, any>
      >
        query={fetchStationChecklistItems}
        variables={{
          stationId: station.id,
        }}
      >
        {({ loading, error, data, refetch }) => (
          <Loader
            {...{
              loading,
              error,
            }}
          >
            <ChecklistPage
              data={data}
              variables={{
                stationId: station.id,
              }}
              stationId={station.id}
              refetch={refetch}
            />
          </Loader>
        )}
      </Query>
    )}
  </StationPage>
)

export default StationChecklistPage
